/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  PerformanceProtocolGetAllSectionsRequest,
  PerformanceProtocolGetAllSectionsResponse,
  PerformanceProtocolGetAssetCsvRequest,
  PerformanceProtocolGetAssetDataRequest,
  PerformanceProtocolGetAssetDataResponse,
  PerformanceProtocolGetDomainCsvRequest,
  PerformanceProtocolGetDomainDataRequest,
  PerformanceProtocolGetDomainDataResponse,
  PerformanceProtocolGetOverviewCsvRequest,
  PerformanceProtocolGetOverviewDataRequest,
  PerformanceProtocolGetOverviewDataResponse,
  PerformanceProtocolGetStatusCsvRequest,
  PerformanceProtocolGetStatusDataRequest,
  PerformanceProtocolGetStatusDataResponse,
  PerformanceProtocolReportGetListRequest,
  PerformanceProtocolReportGetListResponse,
  PiracyCommonProtocolFileResponse,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class Performance<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags Performance
   * @name GetAllSectionsCreate
   * @request POST:/performance/get_all_sections
   */
  getAllSectionsCreate = (data: PerformanceProtocolGetAllSectionsRequest, params: RequestParams = {}) =>
    this.http.request<PerformanceProtocolGetAllSectionsResponse, any>({
      path: `/performance/get_all_sections`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name GetOverviewDataCreate
   * @request POST:/performance/get_overview_data
   */
  getOverviewDataCreate = (data: PerformanceProtocolGetOverviewDataRequest, params: RequestParams = {}) =>
    this.http.request<PerformanceProtocolGetOverviewDataResponse, any>({
      path: `/performance/get_overview_data`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name GetOverviewCsvCreate
   * @request POST:/performance/get_overview_csv
   */
  getOverviewCsvCreate = (data: PerformanceProtocolGetOverviewCsvRequest, params: RequestParams = {}) =>
    this.http.request<PiracyCommonProtocolFileResponse, any>({
      path: `/performance/get_overview_csv`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name GetStatusDataCreate
   * @request POST:/performance/get_status_data
   */
  getStatusDataCreate = (data: PerformanceProtocolGetStatusDataRequest, params: RequestParams = {}) =>
    this.http.request<PerformanceProtocolGetStatusDataResponse, any>({
      path: `/performance/get_status_data`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name GetStatusCsvCreate
   * @request POST:/performance/get_status_csv
   */
  getStatusCsvCreate = (data: PerformanceProtocolGetStatusCsvRequest, params: RequestParams = {}) =>
    this.http.request<PiracyCommonProtocolFileResponse, any>({
      path: `/performance/get_status_csv`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name GetAssetDataCreate
   * @request POST:/performance/get_asset_data
   */
  getAssetDataCreate = (data: PerformanceProtocolGetAssetDataRequest, params: RequestParams = {}) =>
    this.http.request<PerformanceProtocolGetAssetDataResponse, any>({
      path: `/performance/get_asset_data`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name GetAssetCsvCreate
   * @request POST:/performance/get_asset_csv
   */
  getAssetCsvCreate = (data: PerformanceProtocolGetAssetCsvRequest, params: RequestParams = {}) =>
    this.http.request<PiracyCommonProtocolFileResponse, any>({
      path: `/performance/get_asset_csv`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name GetDomainDataCreate
   * @request POST:/performance/get_domain_data
   */
  getDomainDataCreate = (data: PerformanceProtocolGetDomainDataRequest, params: RequestParams = {}) =>
    this.http.request<PerformanceProtocolGetDomainDataResponse, any>({
      path: `/performance/get_domain_data`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name GetDomainCsvCreate
   * @request POST:/performance/get_domain_csv
   */
  getDomainCsvCreate = (data: PerformanceProtocolGetDomainCsvRequest, params: RequestParams = {}) =>
    this.http.request<PiracyCommonProtocolFileResponse, any>({
      path: `/performance/get_domain_csv`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Performance
   * @name ReportListCreate
   * @request POST:/performance/report/list
   */
  reportListCreate = (data: PerformanceProtocolReportGetListRequest, params: RequestParams = {}) =>
    this.http.request<PerformanceProtocolReportGetListResponse, any>({
      path: `/performance/report/list`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
